var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-container"},[_c('proveedores-selector'),_c('laboratorios-selector'),(!_vm.genericos)?_c('tipo-articulo-selector'):_vm._e(),(!_vm.genericos)?_c('categorias-selector'):_vm._e(),_c('subfamilias-selector')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }